export default "__VITE_ASSET__Cnz6mof$__"